import React from 'react';
import { BASE_GRID_PROPS, BASE_GRID_STATE } from './Types';
import { Component } from '../../dispatcher/modules';
import NavigationGrid from './NavigationGrid';
import { SortDescriptor } from '@progress/kendo-data-query';

/**
 * @class BaseGrid
 * BaseGrid with default props
 */
export default class BaseGrid extends Component<BASE_GRID_PROPS, BASE_GRID_STATE> {
  /**
   * Default grid props
   * @protected gridDefaults
   */
  protected gridDefaults = {
    keyboardShortcuts: true,
    id: 'BaseGrid',
    pageSize: 20,
    pageSizeName: 'size',
    pageNumberName: 'page',
    rowHeight: 45,
    reorderable: true,
    resizable: true,
    sortable: true,
    uniqueField: 'name',
    nonResizableColumns: [],
    nonReordeableColumns: [],
    columns: [],

    onAnyKeyDown: () => {},
    onRowControls: () => {},
    onRowDoubleClick: () => {}
  }

  protected gridRef: any;

  protected setGridReference = (el: any) => {
    this.gridRef = el;
  };

  /**
   * @inheritDoc
   */
  public getFilterData = (isQuery = false) => this.gridRef.gridRef.getFilterData(isQuery)

  /**
   * Return params needed for full dashboard grid request, including columns and advanced filter params
   * @param page
   */
  public getGridFilterParams = (page = 0) => this.gridRef.gridRef.prepareRequestParams(page);

  /**
   * Returns selected row dataItem
   */
  getSelectedRowDataItem = () => this.gridRef.gridRef.getSelectedRowDataItem()

  /**
   * Sets selected row dataItem
   * @param {any} record Row dataItem record
   */
  setSelectedRowDataItem = (record?: any) => {
    this.gridRef.gridRef.setSelectedRowDataItem(record);
  }

  /**
   * @inheritDoc
   */
  public setFilterData = (data: any) => this.gridRef.gridRef.setFilterData(data)

  /**
   * Set sort in NavigationBaseGrid
   * @param {SortDescriptor[]} sort
   */
  public setSort = (sort: SortDescriptor[]):void => {
    this.gridRef.gridRef.setSort(sort);
  }

  /**
   * Reload All Grid Data
   */
  reloadGridData = (params: object = {}, url = '', method: '', saveScroll:boolean) => {
    this.gridRef.gridRef.reloadGridData(params, url, method, saveScroll);
  }

  /**
   * Sync Reload All Grid Data
   * @param params
   * @param url
   * @param method
   * @param saveScroll
   */
  public syncReloadGridData = async (params: object = {}, url = '', method: '', saveScroll: boolean = true) => await this.gridRef.gridRef.syncReloadGridData(params, url, method, saveScroll)

  /**
   * Refreshes Grid Data
   */
  refreshGridData = (params: object = {}, url = '', method: '') => {
    this.gridRef.gridRef.refreshGridData(params, url, method);
  }

  renderBody(): any {
    let props = {
      ...this.gridDefaults,
      ...this.props
    };

    return (
      <NavigationGrid
        {...props}
        ref={this.setGridReference}
      />
    );
  }
}
